import { getSavedLanguage } from "../i18n/config"

export const CheckEnStr = (str:string,t) => {
  let lang = getSavedLanguage()
  let isEn = /^[A-Za-z\s]*$/.test(t(str)) || /[A-Za-z]/.test(t(str))
  if((isEn && (lang === "fa"  || !lang)) || (isEn && lang === "en" && str.length > 100)){
    
    return(t("An error has occurred"))
  }else{
    
    return(t(str))
  }
    
}